import React, { useEffect, useState } from "react";

//import FormData from "./QD.json";
import Question from "./Question";

function VehicleQuestion(props) {
  const FormData = props.QDB;
  const [inputs, setInputs] = useState({});
  const handleValue = (event) => {
    const name = event.target.id;
    const value = event.target.value.replace(",", "");
    const iType = event.target.type;
    if (iType === "radio") {
      setInputs((values) => ({
        ...values,
        [name]: {
          val: event.target.checked,
          valType: iType,
        },
      }));
    } else {
      setInputs((values) => ({
        ...values,
        [name]: { val: value, valType: iType },
      }));
    }
    props.handleValue(event);
  };
  function getQfromNumber(qNumber) {
    var strNum = String(qNumber);
    var returnValue = FormData.find((obj) => {
      return obj["New_#"] === strNum;
    });

    if (returnValue) {
      return returnValue;
    }
  }
  var VQ = getQfromNumber("19A");
  var VQsubID = VQ.Sub_Questions.split(",");
  var Q = [];
  var hasLoan = inputs[`has_vehicle_loan_X_${props.idx}`];
  for (var i = 0; i < VQsubID.length; i++) {
    Q[i] = getQfromNumber(VQsubID[i]);
  }
  return (
    <div>
      {Q.map((question) => {
        var k = question["New_#"] + "_" + props.idx;
        var QID = question.Code_ID + "_" + props.idx;
        if (question["New_#"] === "19C" && props.Q19B === "Yes") {
          return <div key={k}></div>;
        }
        if (question.revealed_if.split(":")[0] !== "19I") {
          return (
            <div key={k}>
              <Question
                Question={question}
                QID={QID}
                handleValue={handleValue}
                getAnswer={props.getAnswer}
                QDB={props.QDB}
              ></Question>
            </div>
          );
        } else {
          if (hasLoan !== undefined) {
            if (hasLoan.val === "Yes")
              return (
                <div key={k}>
                  <Question
                    Question={question}
                    QID={QID}
                    handleValue={handleValue}
                    getAnswer={props.getAnswer}
                    QDB={props.QDB}
                  ></Question>
                </div>
              );
          }
        }
        return <div key={k}></div>;
      })}
    </div>
  );
}

export default VehicleQuestion;
